import i18n from "src/config/i18n";

const PrivacyPolicy2014To2026 = () => {
    const language = i18n.language;
    return (
        <>
            {language === "ko" ? (
                <ul>
                    <li>
                        <h3 className="title">
                            주식회사 파수 개인정보 처리방침
                        </h3>
                        <p className="contents">
                            ‘파수’는 (이하 ‘회사’는) 고객님의 개인정보를
                            중요시하며, “정보통신망 이용촉진 및 정보보호”에 관한
                            법률을 준수하고 있습니다. 회사는 개인정보처리방침을
                            통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와
                            방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한
                            조치가 취해지고 있는지 알려드립니다. 회사는
                            개인정보처리방침을 개정하는 경우 웹사이트
                            공지사항(또는 개별공지)을 통하여 공지할 것입니다. 본
                            방침은 2014년 3월 7일부터 시행됩니다.
                        </p>
                    </li>
                    <li>
                        <h3 className="title">개인정보의 수집 및 이용 목적</h3>
                        <p className="contents">
                            수집하는 개인정보 항목 회사는 상담, 서비스 신청 등을
                            위해 아래와 같은 개인정보를 수집하고 있습니다. 회사는
                            수집한 개인정보를 다음의 목적을 위해 활용합니다.
                        </p>
                        <ul>
                            <li>
                                <ul>
                                    <li className="contents">
                                        ◾ 수집항목 : 이름 , 휴대전화번호 , 회사전화번호
                                        , 이메일 , 회사명 , 직책
                                    </li>
                                    <li className="contents">
                                        ◾ 개인정보 수집방법 : 홈페이지(상담폼,
                                        브로슈어다운로드, 뉴스레터 구독신청, 이벤트
                                        프로모션 신청)
                                    </li>
                                    <li className="contents">
                                        ◾ 정보이용 및 이벤트 신청에 따른 본인확인 ,
                                        개인 식별 , 불만처리 등 민원처리
                                    </li>
                                    <li className="contents">
                                        ◾ 마케팅 및 광고에 활용 이벤트 등 광고성 정보
                                        전달 , 접속 빈도 파악 또는 회원의 서비스 이용에
                                        대한 통계
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3 className="title">개인정보의 보유 및 이용기간</h3>
                        <p className="contents">
                            회사는 개인정보 수집 및 이용목적이 달성된 후에는 예외
                            없이 해당 정보를 지체 없이 파기합니다.
                        </p>
                    </li>
                    <li>
                        <h3 className="title">개인정보의 파기절차 및 방법</h3>
                        <p>
                            회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된
                            후에는 해당 정보를 지체없이 파기합니다. 파기절차 및
                            방법은 다음과 같습니다.
                        </p>
                        <ul>
                            <li className="contents">
                                ◾ 제품 정보이용을 위해 입력하신 개인정보는 목적이
                                달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의
                                서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호
                                사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된
                                후 파기되어집니다. 별도 DB로 옮겨진 개인정보는
                                법률에 의한 경우가 아니고서는 보유되어지는 이외의
                                다른 목적으로 이용되지 않습니다.
                            </li>
                            <li className="contents">
                                ◾ 파기방법 – DB삭제 방법으로 파기합니다.
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3 className="title">개인정보 제공</h3>
                        <ul>
                            <li>
                                <p>
                                    회사는 이용자의 개인정보를 원칙적으로 외부에
                                    제공하지 않습니다. 다만, 아래의 경우에는 예외로
                                    합니다.
                                </p>
                                <ul>
                                    <li className="contents">
                                        ◾ 이용자들이 사전에 동의한 경우
                                    </li>
                                    <li className="contents">
                                        ◾ 법령의 규정에 의거하거나, 수사 목적으로
                                        법령에 정해진 절차와 방법에 따라 수사기관의
                                        요구가 있는 경우
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h4 className="subTitle">수집한 개인정보의 위탁</h4>
                                <p className="contents">
                                    이용자 및 법정 대리인은 언제든지 등록되어 있는
                                    자신 혹은 당해 만 14세 미만 아동의 개인정보를
                                    조회하거나 수정할 수 있으며 가입해지를 요청할 수도
                                    있습니다. 이용자 혹은 만 14세 미만 아동의 개인정보
                                    조회 · 수정을 위해서는 ‘개인정보변경'(또는
                                    ‘회원정보수정’ 등)을 가입해지(동의철회)를 위해서는
                                    “회원탈퇴”를 클릭 하여 본인 확인 절차를 거치신 후
                                    직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은
                                    개인정보관리책임자에게 서면, 전화 또는 이메일로
                                    연락하시면 지체없이 조 치하겠습니다. 귀하가
                                    개인정보의 오류에 대한 정정을 요청하신 경우에는
                                    정정을 완료하기 전까 지 당해 개인정보를 이용 또는
                                    제공하지 않습니다. 또한 잘못된 개인정보를 제3자
                                    에게 이미 제공한 경우에는 정정 처리결과를
                                    제3자에게 지체없이 통지하여 정정이 이루어지도록
                                    하겠습니다. 파수는 이용자 혹은 법정 대리인의
                                    요청에 의해 해지 또는 삭제된 개인정보는 “파수가
                                    수집하는 개인정보의 보유 및 이용기간”에 명시된
                                    바에 따라 처리하고 그 외의 용도로 열람 또는 이용할
                                    수 없도록 처리하고 있습니다.
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3 className="title">
                            개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한
                            사항
                        </h3>
                        <p className="contents">
                            회사는 고객의 선호 사항 등을 기억해 서비스를
                            효율적으로 제공하기 위해 개인정보를 저장하고 조회하는
                            쿠키(Cookie, 이하 ‘쿠키’)를 설치하거나 운용할 수
                            있습니다. 회사는 고객이 웹 브라우저에 접속하면 고객의
                            브라우저에 저장된 쿠키의 내용을 읽고, 추가 정보를 찾아
                            이후 접속할 시 맞춤 서비스를 제공할 수 있습니다.
                            회사가 쿠키를 통해 수집한 고객의 정보는 아래 목적 등을
                            위해 사용될 수 있습니다.
                        </p>
                        <p className="contents">
                            – 고객의 관심 분야에 따라 차별화한 정보 제공
                            <br />
                            – 관심있게 둘러본 내용의 자취를 추적해 추후 접속 때
                            개인 맞춤 서비스 제공
                            <br />
                            – 고객들의 패턴을 분석해 서비스 개편 등의 척도로 활용
                            <br />
                        </p>
                        <p className="contents">
                            고객은 위 목적으로 운영되는 맞춤 서비스를 원치 않을
                            시, 쿠키의 저장을 거부할 수 있습니다.
                        </p>
                    </li>
                    <li>
                        <h3 className="title">개인정보에 관한 민원서비스</h3>
                        <ul>
                            <li>
                                <p className="contents">
                                    회사는 고객의 개인정보를 보호하고 개인정보와
                                    관련한 불만을 처리하기 위하여 아래와 같이 관련
                                    부서 및 개인정보관리책임자를 지정하고 있습니다.
                                </p>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <h3 className="title">개인정보관리 책임자</h3>
                        <ul>
                            <li className="contents">◾ 책임자: 김용길 상무</li>
                            <li className="contents">
                                ◾ 연락처: kimyg@fasoo.com
                            </li>
                            <li className="contents">◾ 담당자 박현수 수석</li>
                            <li className="contents">
                                ◾ 연락처: hspark@fasoo.com
                            </li>
                        </ul>
                        <br />
                        <br />
                        <p>
                            귀하께서는 회사의 서비스를 이용하시며 발생하는 모든
                            개인정보보호 관련 민원을 개인정보관리책임자 혹은
                            담당부서로 신고하실 수 있습니다.
                        </p>
                        <br />
                    </li>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <div>
                            <h3 className="subtitle">개인정보관리책임자</h3>
                            <ul>
                                <li className="contents">◾ 국번없이 118</li>
                                <li className="contents">◾ privacy.kisa.or.kr</li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="subtitle">정보보호마크인증위원회</h3>
                            <ul>
                                <li className="contents">◾ 02-550-9531~2</li>
                                <li className="contents">◾ www.eprivacy.or.kr</li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="subtitle">개인정보관리책임자</h3>
                            <ul>
                                <li className="contents">◾ 국번없이 1301</li>
                                <li className="contents">◾ www.spo.go.kr</li>
                            </ul>
                        </div>
                        <div>
                            <h3 className="subtitle">개인정보관리 책임자</h3>
                            <ul>
                                <li className="contents">◾ 국번없이 182</li>
                                <li className="contents">
                                    ◾ 연락처: cyberbureau.police.go.kr
                                </li>
                            </ul>
                        </div>
                    </div>
                    <br />
                    {/* <button
                        type="button"
                        onClick={() => {
                          showEcoHistoryContent();
                          moveScrollTop();
                        }}
                        className="btn btn-green height h-40 mg mt-10 mr-20"
                      >
                        <span className="policyHistory">
                          변경 전 Wrapsody Eco Cloud 개인정보처리방침 보기 &gt;
                        </span>
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          showWrapsodyHistoryContent();
                          moveScrollTop();
                        }}
                        className="btn btn-green height h-40 mg mt-10"
                      >
                        <span className="policyHistory">
                          변경 전 Wrapsody Cloud 개인정보처리방침 보기 &gt;
                        </span>
                      </button> */}
                </ul>
            ) : language === "en" ? (
                <div className="inner modalWindow">
                    <ul>
                        <li>
                            <h3 className="title">1. General Provisions</h3>
                            <p className="contents">
                                Personal information is defined as information that
                                identifies an individual (including that which can be
                                identified by combining it with other information,
                                when it cannot identify an individual with the
                                relevant information alone) with items that are
                                included in the relevant information about an
                                individual, such as their name and resident
                                registration number.
                            </p>
                            <p className="contents">
                                Fasoo Co., Ltd ("the Company") takes customer
                                information protection first and closely observes all
                                domestic legislation, including the Act on Promotion
                                of Information and Communications Network Utilization
                                and Information Protection, etc. ("Information and
                                Communications Network Act") and Personal Information
                                Protection Act.
                            </p>
                            <p className="contents">
                                The Company's privacy policy provides information
                                regarding the purposes and uses of the personal
                                information provided by the customer and indicates the
                                kinds of measures that are taken to protect the
                                personal information through our privacy policy.
                            </p>
                            <p className="contents">
                                The Company reserves the right to change, amend or
                                modify this Privacy Policy of Wrapsody & Wrapsody eCo
                                Services ("the Services") in accordance with
                                applicable law, regulations, and policies, and, in
                                such case, the Company discloses the privacy policy on
                                the Company where the customer can find it with ease.
                            </p>
                        </li>
                        <li>
                            <h3 className="title">
                                2. Items of Collected Personal Information and Methods
                                of Collection
                            </h3>
                            <p className="contents">
                                The company collects and processes the following
                                personal information to provide basic services.
                            </p>
                            <ul>
                                <li>
                                    <h4 className="subTitle">
                                        ① Personal information to be collected
                                    </h4>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th className="th">
                                                    Information to be collected
                                                </th>
                                                <th className="th">Purpose of use</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="td">
                                                    E-mail, name, service usage records, Service
                                                    suspension records, Service termination
                                                    records, IP information, access log, Paid
                                                    plan subscription/ subscription history,
                                                    billing/payment information and history
                                                </td>
                                                <td className="td">
                                                    To secure communication channels to deliver
                                                    service-related notifications, to confirm
                                                    the customer's intention, and to handle
                                                    complaints.
                                                    <br />
                                                    To guide new services/products regarding
                                                    Wrapsody & Wrapsody eCo services.
                                                    <br />
                                                    To use as basic data for checking
                                                    service-related errors and handling
                                                    complaints.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </li>
                                <li>
                                    <h4 className="subTitle">
                                        ② Methods of collecting personal information
                                    </h4>
                                    <p className="contents">
                                        Information is collected through the Company's
                                        website and log analysis program.
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3 className="title">
                                3. Consent to Collection of Personal Information
                            </h3>
                            <p className="contents">
                                The minimum personal information is collected when a
                                user signs up for the Service or while the user uses
                                the Services. In case of collecting personal
                                information, the company informs the items to collect
                                and purposes to a user in advance. If a customer who
                                wants to use the service reads the Terms of Service
                                and this Privacy Policy, enters the required items,
                                and clicks the "Complete" button for sign-up or checks
                                the "OK" or "I Agree" checkbox, it is assumed that the
                                user consents to the processing of personal
                                information.
                            </p>
                        </li>
                        <li>
                            <h3 className="title">
                                4. Retention and Use Period of Personal Information
                            </h3>
                            <p className="contents">
                                When a member withdraws or the purpose of collecting
                                and using personal information is achieved, the
                                personal information of the member is destroyed
                                without delay. However, it is retained for a certain
                                period of time if it is necessary for reasons such as
                                the confirmation of the management obligations
                                regarding transaction in accordance with the
                                provisions of related laws and regulations such as the
                                Commercial Act.
                            </p>
                            <table>
                                <thead>
                                    <tr>
                                        <th className="th">Grounds Act</th>
                                        <th className="th">
                                            Information to be retained.
                                        </th>
                                        <th className="th">Retention Period</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="td">
                                            Consumer Protection Act in Electronic Commerce
                                        </td>
                                        <td className="td">
                                            Records on contract or withdrawal of
                                            subscription
                                        </td>
                                        <td className="td">5 year</td>
                                    </tr>
                                    <tr>
                                        <td className="td">
                                            Consumer Protection Act in Electronic Commerce,
                                            Commercial Law, Basic National Tax Law, Income
                                            Tax Law, Corporate Tax Law, VAT Law
                                        </td>
                                        <td className="td">
                                            Records on payment and supply of goods, etc,
                                            commercial accounting books and statements of
                                            business, and documentary evidences
                                        </td>
                                        <td className="td">5 year</td>
                                    </tr>
                                    <tr>
                                        <td className="td">
                                            Consumer Protection Act in Electronic Commerce
                                        </td>
                                        <td className="td">
                                            Records of consumer complaints or disputes
                                        </td>
                                        <td className="td">3 year</td>
                                    </tr>
                                    <tr>
                                        <td className="td">
                                            Communication Secret Protection Act
                                        </td>
                                        <td className="td">Records of site visits</td>
                                        <td className="td">3 month</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                        <li>
                            <h3 className="title">
                                5. The Procedure and Methods to Dispose of Personal
                                Information
                            </h3>
                            <ul>
                                <li>
                                    <h4 className="subTitle">Processes of disposal</h4>
                                    <p className="contents">
                                        Personal information entered by customers for
                                        service subscription is deleted or destroyed in
                                        accordance with the internal policy and
                                        information protection policy according to other
                                        related laws after the purpose of use is achieved
                                        for reasons such as termination of service.
                                        Generally, if there is no debt relationship,
                                        personal information collected when registering as
                                        a member and managed in the form of an electronic
                                        file is immediately deleted upon membership
                                        withdrawal.
                                    </p>
                                </li>
                                <li>
                                    <h4 className="subTitle">Methods of disposal</h4>
                                    <p className="contents">
                                        A. Personal information in written documents:
                                        shredding, incineration, or chemical decomposition
                                    </p>
                                    <p className="contents">
                                        B. Personal information in digital file forms:
                                        deleted by using technology that prevents the
                                        recovery of such records
                                    </p>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3 className="title">
                                6. The Rights of Members and Legal Representatives and
                                How to Exercise the rights
                            </h3>
                            <p className="contents">
                                Registered members and legal representatives can view
                                or modify personal information of their own or
                                children under the age of 14 at any time and may
                                request termination of membership.
                            </p>
                            <p className="contents">
                                The personal information of a member of a child under
                                the age of 14 can be viewed or modified by clicking
                                Account Information. The subscription can be canceled
                                (consent withdrawal) by clicking the "Withdrawal of
                                Membership" and going through the identity
                                verification process. Or the member can contact the
                                person in charge of personal information management by
                                writing, telephone, or email, the company will take
                                action without delay.
                            </p>
                            <p className="contents">
                                If you request to correct an error in personal
                                information, the personal information will not be used
                                or provided to a third party until the correction is
                                completed. If incorrect personal information has
                                already been provided to a third party, we will notify
                                the third party without delay.
                            </p>
                            <p className="contents">
                                The company handles the personal information that is
                                withdrawn or deleted at the request of a member or
                                legal representative as described in "4. Retention and
                                Use Period of Personal Information" and processes it
                                so that it cannot be viewed or used for other
                                purposes.
                            </p>
                            <p className="contents">
                                Please enter your personal information accurately and
                                up to date. Members are responsible for accidents
                                caused by incorrect information entered by members,
                                and you will lose your qualifications for membership
                                if false information such as theft of other
                                information is entered.
                            </p>
                            <p className="contents">
                                Members have an obligation not to infringe on other's
                                information along with the right to privacy. Be
                                careful not to leak personal information of members,
                                including passwords, and be careful not to damage
                                other people's personal information, including posts.
                                If you damage other people's information, you may be
                                punished by the Act on Promotion of Information and
                                Communication Network Utilization and Information
                                Protection, etc.
                            </p>
                        </li>
                        <li>
                            <h3 className="title">
                                7. Technical/organizational Management for the
                                Protection of Personal Information
                            </h3>
                            <ul>
                                <li>
                                    <h4 className="subTitle">Technical measures</h4>
                                    <p className="contents">
                                        FASOO takes the following technical measures to
                                        secure the stability of the personal information
                                        of our customers, so that there is no loss, theft,
                                        leakage, external attack or damage to the
                                        information.
                                    </p>
                                    <ul>
                                        <li>
                                            <p className="contents">
                                                ① The personal information of the customer is
                                                secured using passwords, and important data is
                                                protected with a special security function by
                                                encrypting or locking the file and the
                                                transmission data.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ② The Company selects the security solution
                                                (SSL or SET) for the safe transmission of
                                                personal information, using an encrypted
                                                algorithm.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ③ The Company is fully engaged in security
                                                matters by using a firewall system and a
                                                vulnerability analysis system on each server,
                                                to prevent external attacks such as hacking.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <h4 className="subTitle">
                                        Organizational measures
                                    </h4>
                                    <ul>
                                        <li>
                                            <p className="contents">
                                                ① For the safe protection of personal
                                                information, we are operating major systems
                                                and facilities with certified information
                                                protection management systems by an objective
                                                certification body.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ② The Company implemented required processes
                                                to access personal information and to manage
                                                and ensure the employees are aware of and
                                                follow the processes.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ③ The Company shall minimize the number of
                                                persons authorized to access personal
                                                information on customers as follows.
                                            </p>
                                            <ul>
                                                <li>
                                                    <p className="contents">
                                                        a. Those who conduct direct marketing
                                                        activities toward users
                                                    </p>
                                                </li>
                                                <li>
                                                    <p className="contents">
                                                        b. Those who manage personal information
                                                        including Privacy Supervisor and Privacy
                                                        Personnel
                                                    </p>
                                                </li>
                                                <li>
                                                    <p className="contents">
                                                        c. Those who are obligated to handle
                                                        personal information due to business
                                                    </p>
                                                </li>
                                            </ul>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ④ The Company implemented required processes
                                                to access personal information and to manage
                                                and ensure the employees are aware of and
                                                follow the processes, and holds regular
                                                company training and outsourced training for
                                                employees who deal with personal information
                                                to acquire new security technology and methods
                                                of protecting personal information.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑤ Transferring duties and responsibilities
                                                between people who handles personal
                                                information is performed thoroughly while
                                                security is maintained. We clarify where the
                                                responsibility lies for personal information
                                                accidents after employees leave the company or
                                                join the Company.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑥ The computer room and data storage room are
                                                set as special protected areas to control
                                                access.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑦ When processing a customer's personal
                                                information using a computer, a person with
                                                access to the personal information is
                                                designated and assigned an identification code
                                                (ID) and password, and the password is
                                                regularly updated.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑧ The company prevents information leakage by
                                                employees in advance by requiring new
                                                employees to sign the Privacy Protection
                                                Pledge when hiring, and establishes and
                                                constantly implements internal procedures to
                                                audit the implementation of personal
                                                information processing policies and compliance
                                                with employees.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑨ The company prevents the person who handled
                                                the customer's personal information from
                                                compromising, infringing, or divulging the
                                                personal information by requiring them to sign
                                                the Privacy Protection Pledge when they
                                                retire.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑩ The Company check the customer's identity
                                                when collecting or providing payment
                                                information such as credit card numbers and
                                                bank settlement accounts for the purpose of
                                                signing service contracts and providing
                                                services.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑪ The company is not responsible for accidents
                                                or events caused by a user's personal mistake
                                                or basic internet risk. Each member should
                                                appropriately manage own ID and password and
                                                be responsible for it for personal information
                                                protection. Also, it is recommended to avoid
                                                using an easy password that others might be
                                                able to guess and to change the password
                                                regularly.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑫ When you want to stop using our service
                                                while you are logged in to our website on a
                                                shared PC, make sure that you have logged out
                                                and close the webpage before moving to another
                                                website. Otherwise, information such as e-mail
                                                and password can be easily leaked to others
                                                through the browser.
                                            </p>
                                        </li>
                                        <li>
                                            <p className="contents">
                                                ⑬ In other cases of personal information loss,
                                                disclosure, falsification and damage due to a
                                                mistake by an internal managing staff or a
                                                technological management accident, the Company
                                                will inform you instantly and look for
                                                appropriate response and compensation method.
                                            </p>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <h3 className="title">
                                8. Personal Information Management Officer
                            </h3>
                            <p className="contents">
                                We value the Personal Information of our customers and
                                try our best not to prevent member's personal
                                information from being damaged, infringed, or leaked.
                                In the event of an infringement of a member's personal
                                information due to the Company's fault, we notify the
                                member in accordance with the procedures and methods
                                prescribed by the relevant laws and regulations such
                                as the Personal Information Protection Act and the
                                Information and Communication Network Act and report
                                to related organization. However, the Company is not
                                responsible for information damage by unexpected
                                accident caused by basic network threats such as
                                hacking occurring despite technological security
                                measures in place and disputes over posts written by
                                visitor.
                            </p>
                            <p className="contents">
                                The Company appointed a Personal Information Manager
                                and a relevant department as below, to protect the
                                personal information of our customers and to take care
                                of any complaints and inquiries related to this
                                information.
                            </p>
                            <table>
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Personal Information Manager</th>
                                        <th scope="col">
                                            Personal Information Management Staff
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Name</th>
                                        <td className="td">Young-gil Kim</td>
                                        <td className="td">Hyunsu Park</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Title</th>
                                        <td className="td">Managing Director</td>
                                        <td className="td">
                                            Principal Research Engineer
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="row">E-mail</th>
                                        {/* <td colSpan={2}>kimyg@fasoo.com</td> */}
                                        <td className="td">kimyg@fasoo.com</td>
                                        <td className="td">hspark@fasoo.com</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">Phone</th>
                                        <td colSpan={2}>82)2-300-9120</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                        <li>
                            <h3 className="title">
                                9. Obligation for Notification
                            </h3>
                            <p className="contents">
                                The current privacy policy was revised on January 31,
                                2018. Should there be information to be added,
                                deleted, and edited according to government policies
                                or a change in the security technology, notification
                                of this will be provided via the website at least
                                seven days before the revision.
                            </p>
                            <p className="contents">
                                The privacy policy takes effect on June 1, 2023
                            </p>
                        </li>
                    </ul>
                    {/* <button
                      type="button"
                      onClick={() => {
                        showEcoHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10 mr-20"
                    >
                      <span className="policyHistory">
                        See past Wrapsody eCo Service privacy policy &gt;
                      </span>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        showWrapsodyHistoryContent();
                        moveScrollTop();
                      }}
                      className="btn btn-green height h-40 mg mt-10"
                    >
                      <span className="policyHistory">
                        See past Wrapsody Service privacy policy &gt;
                      </span>
                    </button> */}
                </div>
            ) : <></>}
        </>
    );
};

export default PrivacyPolicy2014To2026;